import { useQuery } from "@tanstack/react-query";

async function fetchDefaultVoice() {
  const res = await fetch("/api/resemble", {
    method: "GET",
  });
  if (!res.ok) {
    throw new Error("Failed to fetch voice");
  }

  const v = await res.json();
  if (v.voice.name) {
    return {
      name: v.voice.name,
    };
  }
  throw new Error("No voice found");
}

export const useStreamingVoice = () => {
  return useQuery({
    queryKey: ["voice"],
    queryFn: fetchDefaultVoice,
  });
};
